import { ACTIVITY_TABS } from "./activity.constants.ts";
import type { ActivityTabId } from "./activity.constants.ts";

/**
 * Activity, and the access trail.
 *
 * `aria-current="page"` on a `<nav>`, matching `Verifications.tsx`, rather than
 * the `role="tablist"` strip `WorkTabs.tsx` builds. Two panels, no roving
 * tabindex to manage, and each tab's `lead` says what its panel is — which this
 * screen needs more than most, because the two tabs look alike and one of them
 * is allowed to lose a line while the other is not.
 */
export function ActivityTabs({
  active,
  onSelect,
}: {
  active: ActivityTabId;
  onSelect: (tab: ActivityTabId) => void;
}) {
  return (
    <nav className="activity__tabs" aria-label="Audit log sections">
      {ACTIVITY_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className="activity__tab"
          aria-current={tab.id === active ? "page" : undefined}
          onClick={() => onSelect(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
